<template>
  <div class="container">
    <h4 class="is-size-6-mobile is-size-5-tablet">
      <span class="countTotal">({{ $t("graphReport.all") }} {{ count }} | {{ pieces }})</span>
    </h4>
    <div class="box">
      <div class="columns is-multiline is-mobile">
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("graphReport.from_date") }}:</label>
            <date-picker
                format="DD/MM/YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm"
                type="datetime"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
                class="is-fullwidth"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("graphReport.to_date") }}:</label>
            <date-picker
                format="DD/MM/YYYY HH:mm"
                value-type="YYYY-MM-DD HH:mm"
                type="datetime"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
                class="is-fullwidth"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("graphReport.report_type") }}:</label>
            <div class="select is-fullwidth">
              <select class="input" v-model="report_type">
                <option value="shipment">{{ $t("graphReport.bills_count") }}</option>
                <option value="freight">{{ $t("graphReport.freight") }}</option>
                <option value="price">{{ $t("graphReport.goods_price") }}</option>
                <option value="cod">{{ $t("graphReport.cod_bills_count") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("graphReport.amount_type") }}:</label>
            <div class="select is-fullwidth">
              <select class="input" v-model="shipment_type">
                <option value="created">{{ $t("graphReport.created_amount") }}</option>
                <option value="success">{{ $t("graphReport.delivered_amount") }}</option>
                <option value="not_success">{{ $t("graphReport.pending_parcels") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12-mobile is-6-tablet is-3-desktop">
          <div class="control">
            <label class="label">{{ $t("graphReport.show") }}:</label>
            <div class="select is-fullwidth">
              <select class="input" v-model="bar_limit">
                <option value="50">{{ $t("graphReport.top_branches", { n: 50 }) }}</option>
                <option value="100">{{ $t("graphReport.top_branches", { n: 100 }) }}</option>
                <option value="200">{{ $t("graphReport.top_branches", { n: 200 }) }}</option>
                <option value="all">{{ $t("graphReport.all") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="buttons is-centered-mobile">
            <button class="button is-rounded is-fullwidth-mobile" @click="fetchData()">
              <span class="icon">
                 <i class='fal fa-search'></i>
              </span>
              <span>{{ $t("graphReport.search") }}</span>
            </button>
            <button class="button is-rounded is-fullwidth-mobile" @click="printChartPDF()">
              <span class="icon">
                 <i class='fal fa-file-pdf'></i>
              </span>
              <span>PDF</span>
            </button>
            <button class="button is-primary is-rounded is-fullwidth-mobile" @click="printChartExcel()">
              <span class="icon">
                   <i class='fal fa-file-excel'></i>
              </span>
              <span>EXCEL</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <p v-if="!loaded" class="barCount">
      {{ $t("graphReport.showing_branches_of_total", { shown: visibleChartData.labels.length, total: chartData.labels.length }) }}
    </p>
    <div class="chartAreaWrapper">
      <barChart id="barChart"
                class="walking-speed-chart"
                v-if="!loaded"
                :key="bar_limit"
                :chartData='visibleChartData'
                :report_type="chart_report_type"
                :style="{ width: responsiveChartWidth + 'px', minHeight: '400px' }"
      />
    </div>
    <Loading v-if="loaded"/>
  </div>
</template>

<script>
import barChart from '@/components/Chart/BarChart'
import Exporter from "vue-chartjs-exporter";
import XLSX from 'xlsx'
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "@/views/Loading";

export default {
  name: "graph",
  data() {
    return {
      start_date: moment(new Date()).format('YYYY-MM-DD 00:00'),
      end_date: moment(new Date()).format('YYYY-MM-DD HH:mm'),
      loaded: true,
      chartData: {
        labels: [],
        qty: [],
        freight: [],
        price: [],
      },
      excelData: {},
      count: 0,
      pieces: 0,
      chartOptions: {},
      date_type: 'day',
      report_type: 'shipment',
      shipment_type: 'created',
      bar_limit: '50',
      chart_report_type: 'shipment' // the type chartData was fetched for; the picker can redraw before the next search
    };
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },

    printChartPDF() {
      let bar = document.getElementById("barChart");
      const exp = new Exporter([bar]);
      exp.export_pdf().then((pdf) => pdf.save(this.$t('graphReport.pdf_file_name', { from: moment(this.start_date).format('DD-MM-YYYY'), to: moment(this.end_date).format('DD-MM-YYYY') })));
    },
    printChartExcel() {
      const dataWS = XLSX.utils.json_to_sheet(this.excelData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, this.$t('graphReport.excel_file_name', { from: moment(this.start_date).format('DD-MM-YYYY'), to: moment(this.end_date).format('DD-MM-YYYY') }))
    },
    fetchData() {
      this.loaded = true
      this.$http.get("report/chart", {
        params: {
          report_type: this.report_type,
          shipment_type: this.shipment_type,
          start_date: this.start_date,
          end_date: this.end_date
        }
      }).then((res) => {
        const dataSet = {
          labels: [],
          qty: [],
          freight: [],
          price: [],
        };
        res.data.branch.map((item) => {
          dataSet.labels.push(item.name);
          dataSet.qty.push(item.qty);
          dataSet.freight.push(item.freight);
          dataSet.price.push(item.price);
          return item;
        })
        this.chartData = dataSet;
        this.chart_report_type = this.report_type;
        if (this.report_type === 'shipment') {
          this.count = this.$t('graphReport.count_bills', { n: this.formatNumber(res.data.total_qty) })
        } else if (this.report_type === 'freight') {
          this.count = this.$t('graphReport.amount_kip', { n: this.formatNumber(res.data.total_freight) })
        }else if (this.report_type === 'cod') {
          this.count = this.$t('graphReport.count_bills', { n: this.formatNumber(res.data.total_qty) })
        } else {
          this.count = this.$t('graphReport.amount_kip', { n: this.formatNumber(res.data.total_price) })
        }
        this.pieces = this.$t('graphReport.count_boxes', { n: this.formatNumber(res.data.total_pieces) })
        this.excelData = res.data.branch;
        this.loaded = false
      }).catch((error) => {
        console.log(error)
        this.loaded = false
      });
    },
    formatNumber(value) {
      let p = value.toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, value, i) {
        return value === "-" ? acc : value + (i && !(i % 3) ? "," : "") + acc;
      }, "")
    }
  },
  mounted() {
    this.fetchData();
  },

  computed: {
    // The API returns branches biggest first; only the bars are cut, totals and Excel keep every branch.
    visibleChartData() {
      const limit = this.bar_limit === 'all' ? this.chartData.labels.length : Number(this.bar_limit);
      return {
        labels: this.chartData.labels.slice(0, limit),
        qty: this.chartData.qty.slice(0, limit),
        freight: this.chartData.freight.slice(0, limit),
        price: this.chartData.price.slice(0, limit),
      };
    },
    chartWidth() {
      const baseWidth = 20; // Minimum width per bar
      return Math.max(this.chartData.labels.length * baseWidth, window.innerWidth);
    },
    responsiveChartWidth() {
      const isMobile = window.innerWidth < 768;
      const isTablet = window.innerWidth >= 768 && window.innerWidth < 1024;
      
      if (isMobile) {
        const baseWidth = 30; // Wider bars on mobile for better touch
        return Math.max(this.visibleChartData.labels.length * baseWidth, window.innerWidth - 40);
      } else if (isTablet) {
        const baseWidth = 25;
        return Math.max(this.visibleChartData.labels.length * baseWidth, window.innerWidth - 60);
      } else {
        const baseWidth = 20;
        return Math.max(this.visibleChartData.labels.length * baseWidth, window.innerWidth - 100);
      }
    }
  },

  components: {
    barChart,
    DatePicker,
    Loading
  },
}
</script>

<style scoped lang="scss">
.chartAreaWrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 0;
  
  @media (max-width: 768px) {
    padding: 5px 0;
  }
}

.walking-speed-chart {
  height: 100%;
  min-height: 400px;
  transition: width 0.3s ease;
  
  @media (max-width: 768px) {
    min-height: 300px;
  }
}

.countTotal {
  display: inline-block;
  word-break: break-word;
}

.box {
  @media (max-width: 768px) {
    padding: 1rem;
  }
}

.buttons {
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    
    .button {
      margin-bottom: 0.5rem;
      width: 100%;
    }
  }
  
  @media (min-width: 769px) {
    .button {
      margin-right: 0.5rem;
    }
  }
}

.select, .mx-datepicker {
  @media (max-width: 768px) {
    width: 100%;
  }
}

::v-deep .mx-datepicker {
  width: 100%;
  
  .mx-input {
    width: 100%;
  }
}
</style>
